import api from 'api';

export const loadLookalikeAudiencesPartnerAudience = api(
  'GET /api/partner-audiences/:partnerAudience/lookalike-audiences'
);
